var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { defineMessages, injectIntl, FormattedMessage } from "react-intl";
import TRC20 from "../../../assets/img/payment/networks/tron.svg";
import ERC20 from "../../../assets/img/payment/networks/etherium.svg";
import BEP20 from "../../../assets/img/payment/networks/bep20.svg";
import POLYGON from "../../../assets/img/payment/networks/polygon-matic-logo.png";
import copyIcon from "../../../assets/img/icon-copy.svg";
import classNames from "classnames";
import { checkStatusUzdtWallet, createWalletUzdt, clearUsdtState, } from "../../../actions/recharge/creators/usdt";
import QrCode from "react-qrcode-svg";
import Loader from "../../Loader";
import usdtIcon from "../../../assets/img/footer/usdt.svg";
import { ETH, POL, BNB, TRX, USDT } from "../../../constants/CryptoCurrencies";
import { resourceNames } from "../../../constants/accountResourceNames";
var statuses = defineMessages({
    1: {
        id: "member-area.recharge.usdt_status_panding",
        defaultMessage: "Ваш платеж еще не поступил. Попробуйте позже",
    },
    2: {
        id: "member-area.recharge.usdt_status_success",
        defaultMessage: "Ваш платеж успешно поступил на указанный крипто-кошелек. Если денежные средства не были начислены на ваш баланс обратитесь в тех поддержку",
    },
    3: {
        id: "member-area.recharge.usdt_status_rejected",
        defaultMessage: "Ваш запрос был просрочен",
    },
    desc_for_button: {
        id: "recharge.usdt.after_transfer",
        defaultMessage: "После осуществления перевода нажмите на кнопку",
    },
});
var errorMessages = defineMessages({
    "-100": {
        id: "member-area.selfblocking_server_error",
        defaultMessage: "Что-то пошло не так, попробуйте позже",
    },
    "-3": {
        id: "member-area.recharge_request_not_found",
        defaultMessage: "реквест не найден",
    },
    "-2": {
        id: "member-area.recharge_form_user_not_found",
        defaultMessage: "Игрок не найден",
    },
    "-1": {
        id: "member-area.recharge_faild_currency_request",
        defaultMessage: "Ошибка при запросе курса валют",
    },
    "-11": {
        id: "member-area.selfblocking_server_error",
        defaultMessage: "Что-то пошло не так, попробуйте позже",
    },
});
var networks = [
    { value: TRX, label: "TRC20", icon: TRC20 },
    { value: ETH, label: "ERC20", icon: ERC20 },
    { value: BNB, label: "BEP20", icon: BEP20 },
    { value: POL, label: "ERC20(Polygon)", icon: POLYGON },
];
var minAmount = 1;
var UsdtForm = /** @class */ (function (_super) {
    __extends(UsdtForm, _super);
    function UsdtForm(props) {
        var _this = _super.call(this, props) || this;
        _this.getReqBody = function () {
            return {
                GamblerId: _this.props.gamblerId,
                Chain: _this.state.network,
                Currency: USDT,
            };
        };
        _this.startTimer = function () {
            var expTime = _this.props.usdt.get("infoWallet")
                ? _this.props.usdt.get("infoWallet").ExpirationDate
                : 0;
            var timeout = new Date(expTime).getTime() - new Date().getTime();
            if (timeout < 0 && _this.props.usdt.get("infoWallet")) {
                _this.setState({
                    timer: "00:00",
                }, function () { return window.location.reload(); });
                return;
            }
            var minutes = Math.floor((timeout / 1000 / 60) << 0);
            var seconds = Math.floor((timeout / 1000) % 60);
            _this.setState({
                timer: "".concat(minutes < 10 ? "0".concat(minutes) : minutes, ":").concat(seconds < 10 ? "0".concat(seconds) : seconds),
            });
        };
        _this.handleSelectNetwork = function (value) {
            if (value === _this.state.network)
                return;
            _this.setState({
                network: value,
            }, function () {
                var reqBody = {
                    GamblerId: _this.props.gamblerId,
                    Chain: _this.state.network,
                    Currency: USDT,
                };
                _this.props.createWalletUzdtAction(reqBody);
                _this.timer = setInterval(_this.startTimer, 1000);
            });
        };
        _this.onHandleCopy = function () {
            var el = document.createElement("textarea");
            el.value = _this.props.usdt.get("infoWallet").Address;
            document.body.appendChild(el);
            el.select();
            document.execCommand("copy");
            document.body.removeChild(el);
        };
        _this.checkStatus = function () {
            _this.props.checkStatusUzdtWalletAction({
                requestId: _this.props.usdt.get("infoWallet").RequestId,
            });
        };
        _this.errorRenderer = function (errorCode) {
            var fallbackMessage = errorMessages[errorCode] || errorMessages["-100"];
            return (_jsx("p", __assign({ className: "content--box__btn__msg", style: { textAlign: "center", color: "tomato" } }, { children: _jsx(FormattedMessage, __assign({}, fallbackMessage, { children: function (msg) { return _jsx("strong", __assign({ className: "regulations" }, { children: msg })); } })) })));
        };
        _this.state = {
            network: networks[0].value,
            timer: "00:00",
        };
        return _this;
    }
    UsdtForm.prototype.componentDidMount = function () {
        this.props.createWalletUzdtAction(this.getReqBody());
        this.timer = setInterval(this.startTimer, 1000);
    };
    UsdtForm.prototype.componentWillUnmount = function () {
        clearInterval(this.timer);
    };
    UsdtForm.prototype.render = function () {
        var _this = this;
        var errorCode = this.props.usdt.get("usdtError");
        if (errorCode)
            return this.errorRenderer(errorCode);
        var firstThreeNetworks = networks.slice(0, 3);
        var lastNetwork = networks.slice(-1)[0];
        var isAddress = this.props.usdt.get("infoWallet") &&
            this.props.usdt.get("infoWallet").hasOwnProperty("Address");
        var stateOfPayment = this.props.usdt.get("state");
        var amount = this.props.usdt.get("amount");
        var currency = resourceNames[this.props.accountResourceId] || "USD";
        if (stateOfPayment === 2 || stateOfPayment === 4) {
            return (_jsx("div", __assign({ className: "usdt-form" }, { children: _jsxs("div", __assign({ style: { display: "flex", flexDirection: "column", alignItems: "center", gap: "20px", marginTop: "10px" } }, { children: [_jsx("img", { src: usdtIcon, alt: "USDT", width: 47, height: 41 }), _jsx("h3", __assign({ className: "usdt-form__title", style: { textAlign: "center" } }, { children: stateOfPayment === 2 ? (_jsx(FormattedMessage, { id: "recharge.usdt.payment_success", defaultMessage: "\u0411\u0430\u043B\u0430\u043D\u0441 \u0443\u0441\u043F\u0435\u0448\u043D\u043E \u043F\u043E\u043F\u043E\u043B\u043D\u0435\u043D \u043D\u0430 {amount} {currency}", values: { amount: amount, currency: currency } })) : (_jsx(FormattedMessage, { id: "recharge.usdt.payment_min", defaultMessage: "\u041C\u0438\u043D\u0438\u043C\u0430\u043B\u044C\u043D\u0430\u044F \u0441\u0443\u043C\u043C\u0430 \u043F\u043E\u043F\u043E\u043B\u043D\u0435\u043D\u0438\u044F {minAmount} {currency}", values: { minAmount: minAmount, currency: currency } })) })), _jsxs("div", __assign({ style: { display: "flex", flexDirection: "column", gap: "10px", width: "100%", marginTop: "20px", alignItems: "center" } }, { children: [_jsx("button", __assign({ className: "usdt-form__submit_cancel", onClick: function () {
                                        _this.props.clearUsdtStateAction();
                                        _this.props.createWalletUzdtAction(_this.getReqBody());
                                    }, style: { maxWidth: "240px" } }, { children: _jsx(FormattedMessage, { id: "recharge.usdt.recharge_again", defaultMessage: "\u041F\u043E\u043F\u043E\u043B\u043D\u0438\u0442\u044C \u0435\u0449\u0435" }) })), _jsx("button", __assign({ className: "usdt-form__submit_button", onClick: function () {
                                        _this.props.history.push("/");
                                    }, style: { maxWidth: "240px" } }, { children: _jsx(FormattedMessage, { id: "recharge.usdt.play_now", defaultMessage: "\u041A \u0438\u0433\u0440\u0435!" }) }))] }))] })) })));
        }
        return (_jsxs("div", __assign({ className: "usdt-form" }, { children: [this.props.usdt.get("fetching") && _jsx(Loader, {}), _jsxs("div", __assign({ className: "usdt-form__content" }, { children: [_jsx("h1", __assign({ className: "usdt-form__title" }, { children: _jsx(FormattedMessage, { id: "recharge.usdt.min_amount", defaultMessage: "\u041C\u0438\u043D\u0438\u043C\u0430\u043B\u044C\u043D\u0430\u044F \u0441\u0443\u043C\u043C\u0430 \u043F\u043E\u043F\u043E\u043B\u043D\u0435\u043D\u0438\u044F 1 USDT" }) })), _jsx("p", __assign({ className: "usdt-form__descr" }, { children: _jsx(FormattedMessage, { id: "recharge.usdt.min_amount_warning", defaultMessage: "\u041F\u0435\u0440\u0435\u0432\u043E\u0434\u044B \u043C\u0435\u043D\u044C\u0448\u0435 \u044D\u0442\u043E\u0439 \u0441\u0443\u043C\u043C\u044B \u043D\u0435 \u0431\u0443\u0434\u0443\u0442 \u0437\u0430\u0447\u0438\u0441\u043B\u0435\u043D\u044B!" }) })), _jsxs("div", __assign({ style: { display: "flex", alignItems: "center", gap: "10px" } }, { children: [_jsx("img", { src: usdtIcon, alt: "USDT", width: 28, height: 28 }), _jsxs("h4", { children: [_jsx(FormattedMessage, { id: "recharge.usdt.exchange_rate", defaultMessage: "\u041E\u0431\u043C\u0435\u043D\u043D\u044B\u0439 \u043A\u0443\u0440\u0441" }), ": 1 USDT = ", isAddress ? this.props.usdt.get("infoWallet").Rate : 0, " ", currency] })] })), _jsx("br", {}), _jsxs("div", __assign({ className: "usdt-form__networks" }, { children: [_jsx("p", __assign({ className: "usdt-form__networks_title" }, { children: _jsx(FormattedMessage, { id: "recharge.usdt.choose_network", defaultMessage: "\u0412\u044B\u0431\u0435\u0440\u0438\u0442\u0435 \u0441\u0435\u0442\u044C" }) })), _jsx("div", __assign({ className: "usdt-form__networks_list" }, { children: firstThreeNetworks.map(function (network, index) { return (_jsxs("div", __assign({ className: classNames("usdt-form__networks_list_item", {
                                            active: _this.state.network === network.value,
                                        }), onClick: function () { return _this.handleSelectNetwork(network.value); } }, { children: [_jsx("img", { className: "usdt-form__networks_item_img", src: network.icon, alt: network.label, width: 28, height: 28 }), _jsx("span", __assign({ className: "usdt-form__networks_item_value" }, { children: network.label }))] }), network.value)); }) }))] })), _jsx("div", __assign({ className: "usdt-form__networks" }, { children: _jsx("div", __assign({ className: "usdt-form__networks_list" }, { children: _jsxs("div", __assign({ className: classNames("usdt-form__networks_list_item", {
                                        active: this.state.network === lastNetwork.value,
                                    }), onClick: function () { return _this.handleSelectNetwork(lastNetwork.value); } }, { children: [_jsx("img", { className: "usdt-form__networks_item_img", src: lastNetwork.icon, alt: lastNetwork.label, width: 28, height: 28 }), _jsx("span", __assign({ className: "usdt-form__networks_item_value" }, { children: lastNetwork.label }))] }), lastNetwork.value) })) })), isAddress && (_jsxs("div", __assign({ className: "usdt-form__wallet" }, { children: [_jsx("p", __assign({ className: "usdt-form__wallet_label" }, { children: _jsx(FormattedMessage, { id: "recharge.usdt.transfer_amount", defaultMessage: "\u041F\u0435\u0440\u0435\u0432\u0435\u0434\u0438\u0442\u0435 \u0436\u0435\u043B\u0430\u0435\u043C\u0443\u044E \u0441\u0443\u043C\u043C\u0443 (\u043D\u0435 \u043C\u0435\u043D\u0435\u0435 1 USDT) \u043D\u0430 \u043A\u043E\u0448\u0435\u043B\u0435\u043A:" }) })), _jsxs("div", __assign({ className: "usdt-form__wallet_address" }, { children: [_jsx("b", __assign({ className: "usdt-form__wallet_address_value" }, { children: this.props.usdt.get("infoWallet").Address })), _jsx("button", __assign({ className: "usdt-form__wallet_address_copy" }, { children: _jsx("img", { onClick: this.onHandleCopy, src: copyIcon, alt: "copy" }) }))] })), _jsx("div", __assign({ className: "usdt-form__wallet_qrcode" }, { children: _jsx(QrCode, { data: this.props.usdt.get("infoWallet").Address, height: 250, width: 250 }) }))] }))), isAddress && (_jsxs("div", __assign({ className: "usdt-form__submit" }, { children: [_jsx("p", __assign({ className: "usdt-form__submit_timer", style: {
                                        fontSize: "16px",
                                        textAlign: "center",
                                        fontWeight: "600",
                                    } }, { children: !(stateOfPayment > 1) &&
                                        this.props.intl.formatMessage({ id: "recharge.usdt.awaiting_payment", defaultMessage: "Мы ожидаем ваш платеж" }) + ": " + this.state.timer })), _jsx("p", __assign({ className: "usdt-form__submit_info" }, { children: this.props.intl.formatMessage(statuses[stateOfPayment || "desc_for_button"]) })), stateOfPayment !== 2 && stateOfPayment !== 3 ? (_jsx("button", __assign({ className: "usdt-form__submit_button", onClick: this.checkStatus, disabled: !isAddress }, { children: _jsx(FormattedMessage, { id: "recharge.usdt.transfer_completed", defaultMessage: "\u041F\u0435\u0440\u0435\u0432\u043E\u0434 \u0441\u043E\u0432\u0435\u0440\u0448\u0435\u043D" }) }))) : null, _jsx("button", __assign({ className: "usdt-form__submit_cancel", onClick: this.props.handleClearSelect }, { children: stateOfPayment ?
                                        _jsx(FormattedMessage, { id: "recharge.usdt.close", defaultMessage: "\u0417\u0430\u043A\u0440\u044B\u0442\u044C" }) :
                                        _jsx(FormattedMessage, { id: "recharge.usdt.cancel", defaultMessage: "\u041E\u0442\u043C\u0435\u043D\u0430" }) })), _jsx("br", {}), _jsx("br", {}), _jsx("p", __assign({ className: "usdt-form__submit_info" }, { children: _jsx(FormattedMessage, { id: "recharge.usdt.payment_timeout", defaultMessage: "\u0415\u0441\u043B\u0438 \u043F\u043B\u0430\u0442\u0435\u0436 \u043D\u0435 \u043F\u043E\u0441\u0442\u0443\u043F\u0438\u043B \u0432 \u0442\u0435\u0447\u0435\u043D\u0438\u0435 20 \u043C\u0438\u043D\u0443\u0442, \u043F\u0440\u0438\u0448\u043B\u0438\u0442\u0435 \u043D\u0430\u043C \u0432 \u0447\u0430\u0442 \u0445\u044D\u0448 \u0442\u0440\u0430\u043D\u0437\u0430\u043A\u0446\u0438\u0438." }) }))] })))] }))] })));
    };
    return UsdtForm;
}(React.Component));
var mapStateToProps = function (state) {
    return {
        usdt: state.recharge.get("usdt"),
        gamblerId: state.auth.user.gamblerId,
        accountResourceId: state.auth.user && state.auth.user.accountResourceId,
    };
};
var mapDispatchToProps = {
    createWalletUzdtAction: createWalletUzdt,
    checkStatusUzdtWalletAction: checkStatusUzdtWallet,
    clearUsdtStateAction: clearUsdtState,
};
export default connect(mapStateToProps, mapDispatchToProps)(withRouter(injectIntl(UsdtForm)));



// WEBPACK FOOTER //
// ./src/components/recharge/forms/UsdtForm.jsx